import { Field } from 'kts-scaffold-framework/utils/doc';

const toStringChinese = (amount: any) => {
    if (Number(amount) === Number(amount)) {
        if (Number(amount) > 0) {
            return Field.toStringChinese(amount);
        } else if (Number(amount) === 0) {
            return '零'
        } else {
            const positiveNum = Math.abs(amount)
            return `负${Field.toStringChinese(positiveNum)}`;
        }
    }
    return '';
}

const zeroizeFront = (amount: any) => {
    if (typeof amount === 'string') {
        const value = amount.trim();
        if (value.length > 0) {
            return isNaN(Number(value)) ? '' : String(Number(value));
        }
        return '';
    } else if (typeof amount === 'number') {
        return amount;
    }
    return '';
}

export default {
    toStringChinese,
    zeroizeFront,
}


// WEBPACK FOOTER //
// ./src/utils/Doc/Money.ts